export interface SearchSelectLabels {
  /** Beside the spinner while a request is out. */
  loading: string;
  /** The search came back with nothing. */
  empty: string;
  /** The search failed. */
  error: string;
  /** Shown while fewer than `minQueryLength` characters are typed. */
  hint: string;
  /** Names the button that empties the field. */
  clear: string;
  /** Names the button that opens the list. */
  open: string;
  /** Names a chip's ×, e.g. `(label) => \`Remove ${label}\``. */
  remove: (label: string) => string;
}

/*
 * English, because the first caller is the staff app. Every one of them is
 * overridable per field: the customer app is Dutch and says so.
 */
export const DEFAULT_LABELS: SearchSelectLabels = {
  loading: 'Searching…',
  empty: 'No results',
  error: 'Could not load results',
  hint: 'Keep typing to search',
  clear: 'Clear selection',
  open: 'Open list',
  remove: (label) => `Remove ${label}`,
};
